import React, { useState } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import LinearProgress from '@mui/material/LinearProgress'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import './custombar.scss'
import { useTranslation } from 'react-i18next'

const CustomBar = () => {
  // TODO: will be replaced with actual value
  const [value, setValue] = useState(50000)
  const { t } = useTranslation()

  return (
    <div>
      <Typography variant='h5' className='custom-bar-title'>
        {t('property_evaluation.title')}
      </Typography>
      <Box className='custom-bar-container'>
        <LinearProgress
          variant='determinate'
          value={(value / 100000) * 100}
          className='custom-linear-progress'
        />
        <ArrowDropDownIcon
          className='custom-arrow-icon'
          style={{
            left: `calc(${(value / 100000) * 100}% - 20px)`,
          }}
        />
        {/* <Typography variant='body1' className='custom-caption'>
          Current Property Value: ${value.toLocaleString()}
        </Typography> */}
      </Box>
    </div>
  )
}

export default CustomBar
